import { Switch } from '@mantine/core'
import { DatePickerInput } from '@mantine/dates'
import type { TOptions } from 'components/MultiSelect/MultiSelect.types'
import { translate } from 'i18n/i18n'
import moment from 'moment-timezone'
import type { Dispatch, SetStateAction } from 'react'
import { colors } from 'settings/colors'
import { checkAuthorization } from 'utils/checkAuthorization'
import { getDateForDayAndMonthPicker } from 'utils/getDateForDayAndMonthPicker'
import type { TReportStartEnd } from '../../../_utils/formTypesAndStyles'
import { PropertiesSubtitle } from './PropertiesSubtitle'

export const FireBlight = ({
  fireBlight,
  setFireBlight,
  fireBlightStartEnd,
  setFireBlightStartEnd,
  selectedReportProperties,
}: {
  fireBlight: boolean
  setFireBlight: Dispatch<SetStateAction<boolean>>
  fireBlightStartEnd: TReportStartEnd | null
  setFireBlightStartEnd: Dispatch<SetStateAction<TReportStartEnd | null>>
  selectedReportProperties: TOptions[]
}) => {
  const filteredPropertiesByPermission = Object.values(selectedReportProperties).filter(
    (property: TOptions) => {
      return checkAuthorization({
        permission: 'CREATE_REPORT_FIRE_BLIGHT',
        entity: Number(property.value),
      })
    },
  )

  const propertyIds = selectedReportProperties
    ? Object.values(selectedReportProperties).map((obj) => obj.value as string)
    : null

  if (filteredPropertiesByPermission.length < 1) {
    return null
  }

  return (
    <div css={{ paddingBottom: '25px', borderBottom: `1px solid ${colors.grey200}` }}>
      <h4 css={{ fontWeight: '500' }}>
        {translate.phrases.banyanApp('Fire Blight')}
        {PropertiesSubtitle({
          permission: 'CREATE_REPORT_FIRE_BLIGHT',
          propertyIds: propertyIds,
        })}
      </h4>
      <div>
        <Switch
          size="md"
          color="lime"
          label={translate.phrases.banyanApp(
            'Include the fire blight risk for the previous week and risk prediction for the upcoming week',
          )}
          styles={{
            label: { cursor: 'unset', fontSize: 16 },
            track: {
              width: 36,
              cursor: 'unset',
              backgroundColor: fireBlight ? colors.green : undefined,
              borderColor: fireBlight ? colors.green : undefined,
            },
          }}
          checked={fireBlight}
          onChange={() => setFireBlight(!fireBlight)}
        />
      </div>
      <div css={{ marginTop: '15px', display: 'flex' }}>
        <DatePickerInput
          valueFormat={translate.dates.getMomentFormat('MMM D')}
          clearable={false}
          placeholder={translate.phrases.banyanApp('Select start date')}
          monthLabelFormat={translate.dates.getMomentFormat('MMM')}
          value={getDateForDayAndMonthPicker(fireBlightStartEnd?.startDate)}
          onChange={(e) =>
            setFireBlightStartEnd((prevState) => ({
              ...prevState,
              startDate: moment.tz(e, moment.tz.guess()).format('MM-DD'),
            }))
          }
          disabled={!fireBlight}
          css={{ maxWidth: '100%', width: '240px', marginRight: '15px' }}
        />

        <DatePickerInput
          valueFormat={translate.dates.getMomentFormat('MMM D')}
          clearable={false}
          placeholder={translate.phrases.banyanApp('Select end date')}
          value={getDateForDayAndMonthPicker(fireBlightStartEnd?.endDate)}
          monthLabelFormat={translate.dates.getMomentFormat('MMM')}
          onChange={(e) =>
            setFireBlightStartEnd((prevState) => ({
              ...prevState,
              endDate: moment.tz(e, moment.tz.guess()).format('MM-DD'),
            }))
          }
          disabled={!fireBlight}
          css={{ maxWidth: '100%', width: '240px' }}
        />
      </div>
    </div>
  )
}
